<template>
    <div class="">
        <!--        <form class="form" @submit="submitForm">-->
        <!--            <div class="container">-->
        <!--                <div class="pb-12 pt-8">-->
        <!--                    <div class="">-->
        <!--                        <div-->
        <!--                            v-if="!selectedSubscriptionPlan"-->
        <!--                            :class="-->
        <!--                                'm-auto grid max-w-2xl sm:grid-cols-1 ' +-->
        <!--                                ('md:grid-cols-' +-->
        <!--                                    $page.props.studentSubscriptionPlans.length)-->
        <!--                            "-->
        <!--                        >-->
        <!--                            <subscription-price-box-->
        <!--                                v-for="subscriptionPlan in $page.props-->
        <!--                                    .studentSubscriptionPlans"-->
        <!--                                :key="subscriptionPlan.id"-->
        <!--                                :subscription-plan="subscriptionPlan"-->
        <!--                                action="formControl"-->
        <!--                                button-label="Choose This Plan"-->
        <!--                                v-on:selected="selectPlan"-->
        <!--                            ></subscription-price-box>-->
        <!--                        </div>-->

        <!--                        <div-->
        <!--                            v-else-->
        <!--                            class="m-auto grid max-w-2xl grid-cols-1 gap-4 sm:grid-cols-2"-->
        <!--                        >-->
        <!--                            <subscription-price-box-->
        <!--                                :subscription-plan="selectedSubscriptionPlan"-->
        <!--                                action="formControl"-->
        <!--                                button-label="Change plan selection"-->
        <!--                                v-on:selected="selectPlan"-->
        <!--                            ></subscription-price-box>-->
        <!--                            <div class="flex flex-col gap-4">-->
        <!--                                <div class="flex-none">-->
        <!--                                    <div class="font-semibold">-->
        <!--                                        Choose your exam level-->
        <!--                                    </div>-->
        <!--                                    <div-->
        <!--                                        class="text-[12px] font-semibold text-neutral-60"-->
        <!--                                    >-->
        <!--                                        Pricing is the same for all exam levels.-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                                <div-->
        <!--                                    v-for="providerLevel in allProviderLevels"-->
        <!--                                    :key="providerLevel.id"-->
        <!--                                    :class="-->
        <!--                                        'group flex-grow cursor-pointer rounded border border-neutral-20 p-4 hover:bg-primary-darker hover:text-white' +-->
        <!--                                        (formData.selectedProviderLevelId ===-->
        <!--                                        providerLevel.id-->
        <!--                                            ? ' bg-primary-default !text-white'-->
        <!--                                            : ' ')-->
        <!--                                    "-->
        <!--                                    @click="selectExamLevel(providerLevel)"-->
        <!--                                >-->
        <!--                                    <div class="text-[18px] font-semibold">-->
        <!--                                        {{ providerLevel.title }}-->
        <!--                                    </div>-->
        <!--                                    <div class="text-[14px] font-semibold">-->
        <!--                                        {{ providerLevel.description }}-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->

        <!--            <div class="mb-8 mt-4 text-center">-->
        <!--                <button-->
        <!--                    :disabled="!formDirty || !formValid"-->
        <!--                    class="btn btn-lg btn-primary inline-block w-80"-->
        <!--                    type="submit"-->
        <!--                >-->
        <!--                    Checkout &amp; Start Subscription-->
        <!--                </button>-->
        <!--            </div>-->
        <!--        </form>-->
    </div>
</template>

<script>
import SubscriptionPriceBox from "./SubscriptionPriceBox";

export default {
    name: "PurchaseSubscriptionForm",
    components: {
        SubscriptionPriceBox,
    },
    data() {
        return {
            formData: {
                selectedPlanId: null,
                selectedProviderLevelId: null,
            },
            formDirty: false,
            formValid: false,
            errors: {},
        };
    },
    methods: {
        selectPlan(subscriptionPlan) {
            if (this.formData.selectedPlanId) {
                this.formData.selectedPlanId = null;
            } else {
                this.formData.selectedPlanId = subscriptionPlan.id;
            }
        },
        selectExamLevel(examLevel) {
            this.formData.selectedProviderLevelId = examLevel.id;
        },
        submitForm: function (e) {
            e.preventDefault();

            let vm = this;

            if (vm.validateForm()) {
                axios
                    .post("/student/change-provider-level/", {
                        selected_provider_level:
                            vm.formData.selectedProviderLevelId,
                    })
                    .then(function (response) {
                        window.location.href =
                            "/checkout/show-form?selected_plan_id=" +
                            vm.formData.selectedPlanId;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                    });
            }
        },
        validateForm() {
            return !!(
                this.formData.selectedPlanId &&
                this.formData.selectedProviderLevelId
            );
        },
    },
    mounted() {
        let vm = this;
    },
    computed: {
        selectedSubscriptionPlan() {
            let vm = this;
            let selectedSubscriptionPlan = _.filter(
                this.$page.props.studentSubscriptionPlans,
                function (plan) {
                    return plan.id === vm.formData.selectedPlanId;
                }
            )[0];

            return selectedSubscriptionPlan;
        },
    },
    watch: {
        formData: {
            handler(newVal, oldVal) {
                this.formDirty = true;
                this.formValid = this.validateForm();
            },
            deep: true,
        },
    },
};
</script>

<style scoped></style>
